module.exports = __webpack_public_path__ + "static/media/coin.069843c1.svg";